<template>
<transition name="slide-fade">
    <div class="dialog-view" v-if="visible">        
        <div class="rule-modal u-window">           
            <div class="dialog-content">
                <div class="u-btn close" @click="closeModal"></div>
                <div class="dialog-wrapper">
                    <h5 class="title"></h5>

                    <div class="rule-view">
                        <div class="rule-item"><span class="label">【活动时间】</span>2025.12.25-2026.1.25
                        </div>
                        <div class="rule-item"><span class="label">【福泽宝箱】</span>玩家可从自选库选择不同品质的6个游戏道具放入宝物箱后；每个用户仅可兑换一次，建议组成3人结义小队，并选择高品质道具兑换</div>
                        <div class="rule-item"><span class="label">【结义值】</span>玩家可通过游戏神兵、游戏签到、小队消费返还等多种途径获得结义值；且消耗结义值，可获得丰厚奖励</div>
                        <div class="rule-item"><span class="label">【消费返还】</span>活动期间，小队成员消费梦三币，将等额返还结义值（每人上限3000），且每人可单独获得当前小队消费总返还结义值</div>
                        <div class="rule-item"><span class="label">【回归条件】</span>被绑定时的等级需≥11级，神兵值≥20万，且截止至2025年12月25日超过30天未登录游戏可成为回归玩家，且与游戏中回归招募的定义不同</div>
                        <div class="rule-item"><span class="label">【结义小队】</span>小队由3人组成，入队需队长审核，且至少包含1个回归用户</div>
                        <div class="rule-item"><span class="label">【每日签到】</span>此任务对应的是游戏内的每日签到任务</div>
                        <div class="rule-item"><span class="label">【匹配地图】</span>娱乐*三国无双、官渡*经典之战、三国志大战、英霸官渡、天命无双、官渡*天命无双、英霸*天命无双、天命*荆州争霸、军团出征、军团出征巅峰场，仙术师只能通过匹配模式完成任务（中退局、约战不计入）</div>
                        <div class="rule-item"><span class="label">【其他说明】</span>专属武器收集礼，如在本期已完成任务，请及时领取奖励，过期未领将视为放弃，且无法在下一期领取</div>
                        <div class="rule-item"><span class="label">【温馨提醒】</span>本活动中获得的结义值仅可用于本次活动使用，无法继承至下次活动，请注意及时使用</div>
                    </div>

                </div>
            </div>            
        </div> 
        <div class="u-mask"></div>
    </div>
</transition>       
</template>

<style scoped>
.rule-modal{
    /* width: 708px;
    height: 998px;
    background-image: url(~@/assets/images/modal/bg-modal-rule.png);      */
    width: 720px;
}

.title{
    width: 516px;
    height: 55px;
    margin: 0 auto 30px;
    background-image: url(~@/assets/images/modal/title-rule.png);    
}

.rule-view{
    padding: 0 34px;
    color: #776966;
    font-size: 22px;
}

.rule-item{
    margin-bottom: 20px;
}

.rule-view b{
    color: #fe5a1e;
}

.rule-view .label{
    color: #872b06;    
}

@media (min-width: 1024px){
    .rule-modal{
        transform: scale(0.75);
    }
}
</style>

<script>
export default {
    data () {
        return {
            visible : false,
            text : '',
        }
    },
    watch: {
        closed (newVal) {
            if (newVal) {
                this.visible = false
                this.destroyElement()
            }
        }
    },
    created (){
        document.body.style.overflow = 'hidden';
    },
    methods : {
        destroyElement () {
            this.$destroy();
            document.body.style.overflow = ''; // 出现滚动条
            this.$el.parentNode.removeChild(this.$el)
        },       
        closeModal(){
            this.destroyElement()
        },       
    },    
}
</script>